import { render, staticRenderFns } from "./IssueModal.vue?vue&type=template&id=1a672d6a&scoped=true"
import script from "./IssueModal.vue?vue&type=script&lang=js"
export * from "./IssueModal.vue?vue&type=script&lang=js"
import style0 from "./IssueModal.vue?vue&type=style&index=0&id=1a672d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a672d6a",
  null
  
)

export default component.exports